module.exports = __webpack_public_path__ + "static/media/3.15853f7a.png";